import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentBranchDiscount = id => {
  return http.get(
    `${getBaseUrl()}/agent_branch_discount/${id}`
  );
};

export const getConsultationAgentBranchDiscount = (branchId, discountCode) => {
  return http.get(
    `${getBaseUrl()}/consultation_branch_discount_code/${branchId}/${discountCode}`
  );
};

export const getServiceAgentBranchDiscount = (branchId, discountCode) => {
  return http.get(
    `${getBaseUrl()}/service_branch_discount_code/${branchId}/${discountCode}`
  );
};

export const getAgentBranchDiscounts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_discount`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_branch_discount?${paginate}`
  );
};

export const updateAgentBranchDiscount = data => {

  return http.put(
    `${getBaseUrl()}/agent_branch_discount/${data.id}`,
    data
  );
};
export const submitAgentBranchDiscount = data => {

  return http.post(
    `${getBaseUrl()}/agent_branch_discount`,
    data
  );
};
